module.exports = __webpack_public_path__ + "img/reviewer-logo-11.2fdb35c6.png";